import React, { Component } from 'react';
import { Bell, Inbox } from 'lucide-react';
import Inherit from '../../core/inherit';
import NotificationsController from './notifications.controller';
import withNavigate from '../../core/withNavigate';
import { Layout, AnalyticsSkeleton, CardSkeleton, PageHeader, SectionCard, EmptyState } from '../common';
import { NotificationStats, NotificationFilters, NotificationList } from './elements';

class ShelfNotifications extends Inherit(NotificationsController, Component) {
    state = {
        loading: true,
        notifications: [],
        filteredNotifications: [],
        stats: null,
        filterType: 'all',
        filterSeverity: 'all',
        filterRead: 'all'
    };

    render() {
        const { loading, notifications, stats, filterType, filterSeverity, filterRead } = this.state;

        return (
            <Layout current="notifications" user={this.user}>
                <PageHeader icon={<Bell />} title="Notificaciones" description="Gestiona las alertas y notificaciones del sistema" />

                {loading ? (
                    <div className="flex flex-col gap-4">
                        <AnalyticsSkeleton cards={3} />
                        <CardSkeleton rows={8} />
                    </div>
                ) : (
                    <div className="flex flex-col gap-4 animate-in">
                        {stats && <NotificationStats stats={stats} />}

                        <NotificationFilters
                            filterType={filterType}
                            filterSeverity={filterSeverity}
                            filterRead={filterRead}
                            setFilterType={this.setFilterType.bind(this)}
                            setFilterSeverity={this.setFilterSeverity.bind(this)}
                            setFilterRead={this.setFilterRead.bind(this)}
                            markMultipleAsRead={this.markMultipleAsRead.bind(this)}
                            notifications={notifications}
                        />

                        <SectionCard title="Bandeja" description={`${notifications.length} notificaciones`} icon={<Inbox />} flush>
                            {notifications.length === 0 ? (
                                <EmptyState
                                    icon={<Bell />}
                                    title="No hay notificaciones"
                                    description="Las notificaciones aparecerán aquí cuando ocurran eventos importantes"
                                />
                            ) : (
                                <NotificationList
                                    notifications={notifications}
                                    markAsRead={this.markAsRead.bind(this)}
                                    dismissNotification={this.dismissNotification.bind(this)}
                                    deleteNotification={this.deleteNotification.bind(this)}
                                    viewStoreCheck={this.viewNotificationStoreCheck.bind(this)}
                                    viewClient={this.viewNotificationClient.bind(this)}
                                    viewStore={this.viewNotificationStore.bind(this)}
                                />
                            )}
                        </SectionCard>
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfNotifications);
